import { render, staticRenderFns } from "./Postgres.vue?vue&type=template&id=1766dc9a&scoped=true"
import script from "./Postgres.vue?vue&type=script&lang=js"
export * from "./Postgres.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1766dc9a",
  null
  
)

export default component.exports